import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { useValueRef } from '@cian/react-utils';
import { useDropdownController, useFocusOptionController } from '../../../internal/hooks/controllers';
export function useSelectDesktopController(props) {
  var _useDropdownControlle = useDropdownController(props),
    open = _useDropdownControlle.open,
    dropdownActions = _useDropdownControlle.actions;
  var _useFocusOptionContro = useFocusOptionController({
      length: props.options.length
    }),
    focusedIndex = _useFocusOptionContro.focusedIndex,
    focusOptionActions = _useFocusOptionContro.actions;
  var stateRef = useValueRef({
    props: props,
    open: open,
    focusedIndex: focusedIndex
  });
  React.useEffect(function () {
    var _stateRef$current$pro = stateRef.current.props,
      options = _stateRef$current$pro.options,
      value = _stateRef$current$pro.value;
    if (!open) {
      var selectedIndex = options.findIndex(function (option) {
        return value === option.value;
      });
      focusOptionActions.setFocusedIndex(Math.max(selectedIndex, 0));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  var selectOption = function selectOption(index) {
    var props = stateRef.current.props;
    var option = props.options[index];
    if (!option) {
      return;
    }
    var optionValue = option.value;
    var prevValue = props.value;
    if (optionValue !== prevValue) {
      props.onChange(optionValue);
    }
  };
  var selectFocusedOption = function selectFocusedOption() {
    return selectOption(stateRef.current.focusedIndex);
  };
  var actions = _objectSpread(_objectSpread(_objectSpread({}, dropdownActions), focusOptionActions), {}, {
    selectOption: selectOption,
    selectFocusedOption: selectFocusedOption
  });
  return {
    open: open,
    focusedIndex: focusedIndex,
    actions: actions
  };
}